import { FORTEM_URIS } from '@/constants/uris'
import { FeedsICGuidelinesPage } from '@/pages/feeds/ic-guidelines/page'
import { FeedsLayout } from '@/pages/feeds/layout'
import { FeedsProvidersPage } from '@/pages/feeds/providers/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const feedsRoutes = [
  {
    path: FORTEM_URIS.FEEDS.__INDEX__,
    element: <FeedsLayout />,
    handle: {
      title: 'Data Presence',
    },
    children: [
      { path: FORTEM_URIS.FEEDS.PROVIDERS, element: <FeedsProvidersPage /> },
      { path: FORTEM_URIS.FEEDS.IC_GUIDELINES, element: <FeedsICGuidelinesPage /> },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
